<app-toolbar></app-toolbar>
<div class="wrapper">
  <app-sidebar-community></app-sidebar-community>
  <div class="content-primary">
    <router-outlet></router-outlet>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/layout/layout-community/layout-community.component.html